import { useTranslation } from '../hooks/useTranslation'

export function SettingsPage() {
  const { t } = useTranslation()
  return (
    <div className="p-6">
      <h1 className="text-h1 text-text-primary mb-2">{t('settings.title')}</h1>
      <p className="text-body text-text-secondary">{t('settings.coming_soon')}</p>
    </div>
  )
}
